export const CloseClicked = 'travellersFieldMultiroom/closeClicked';
export const ResetClicked = 'travellersFieldMultiroom/resetClicked';
export const AdultsCountChanged = 'travellersFieldMultiroom/adultsCountChanged';
export const ChildrenCountChanged = 'travellersFieldMultiroom/childrenCountChanged';
export const ChildrenAgeChanged = 'travellersFieldMultiroom/childrenAgeChanged';
export const ValueChanged = 'travellersFieldMultiroom/valueChanged';
export const FunctionValueChanged = 'travellersFieldMultiroom/functionValueChanged';
export const RoomAdded = 'travellersFieldMultiroom/roomAdded';
export const RoomRemoved = 'travellersFieldMultiroom/roomRemoved';